import Client from "../Client";
import Exceptions from "../Exceptions";
import { wait } from "../misc/date";
import { getParams } from "../misc/path";
import { MainRouter } from "../routes";
import { login } from "../services/api/account";

const LoginController = {
    
    /** @type {{ error: string, status: "error" | "loggingIn" }} */
    states: {},

    events: {
        async signIn(username, password) {
            const states = LoginController.states;
            states.status = "loggingIn";

            let result;

            try {
                result = await login({ username, password });
            } catch (e) {
                states.error = "Login error";
                states.status = "error";

                return;
            }

            if(!result.ok) {
                const error = Exceptions.evaluations.login(result.data, result.status);
                states.error = error;
                states.status = "error";

                return;
            }
            

            Client.logAccount(result.data.account, result.data.token);
            states.status = null;

            const redirection = getParams()["redirect"];
            if(redirection) MainRouter.goto(redirection);
            else MainRouter.goto("/");
        },

        async goToRegister() {
            MainRouter.goto("/register");
        }
    },
};

export default LoginController;